import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {variableChartOptions} from './variableChartOptions';

require('highcharts/modules/variable-pie')(Highcharts);
const cloneDeep = require('lodash.clonedeep');

export default class VariableChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            variableChartOptions: cloneDeep(variableChartOptions),
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.data !== nextProps.data) {
            const variableChartOptions = cloneDeep(this.state.variableChartOptions);
            variableChartOptions.series[0].data = nextProps.data;
            this.setState({variableChartOptions});
        }
    }

    render() {
        const {title, total, data} = this.props;
        const variableChartOptions = this.state.variableChartOptions;

        return (
            <div className='VariableChart'>
                <div className='stats-title'>{title}</div>
                <div className='chart-container'>
                    <div className='chart-total'>{total}</div>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={variableChartOptions}
                    />
                </div>
                <div className='chart-legend'>
                    {data.map((item, index) => (
                        <div className='chart-legend-item' key={index}>
                            <div className='chart-legend-value'>
                                {total ? ((item.y * 100) / total).toFixed(1) : 0}%
                            </div>
                            <div className='chart-legend-name'>
                                <div className='chart-legend-color'
                                     style={{background: item.color}}
                                />
                                {item.name}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
};